import { IRoute } from "shared/interface/types";
import { LifeOrderRoutes } from "./healthOrderRoute";
import { healthShelfPlanB2CRoutes } from "./shelfPlanRoute/B2CRoute";

export const LifeRoutes: IRoute[] = [...LifeOrderRoutes, ...healthShelfPlanB2CRoutes];
